import {
  SET_ADMIN_NAVIGATION_NODES,
  SET_CHILD_ID,
  SET_PARENT_NODE_DETAILS,
  SET_PREVIOUSLY_VISITED_NODES,
  SET_DIALOG_DETAILS,
} from "./AdminNavigationConstants";

export const setAdminNavigationNodes = nodes => {
  return {
    type: SET_ADMIN_NAVIGATION_NODES,
    payload: nodes,
  };
};

export const setChildId = childId => {
  return {
    type: SET_CHILD_ID,
    payload: childId,
  };
};

export const setParentNodeDetails = parentNodeDetails => {
  return {
    type: SET_PARENT_NODE_DETAILS,
    payload: parentNodeDetails,
  };
};

export const setPreviouslyVisitedNodes = previouslyVisitedNodes => {
  return {
    type: SET_PREVIOUSLY_VISITED_NODES,
    payload: previouslyVisitedNodes,
  };
};

export const setDialogDetails = dialogDetails => {
  return {
    type: SET_DIALOG_DETAILS,
    payload: dialogDetails,
  };
};
